_is_future